import { useSelector } from 'react-redux';
import AthleteDashboard from '../../pages/AthleteDashboard/AthleteDashboard';
import CoachDashboard from '../../pages/CoachDashboard/CoachDashboard';

const RoleBasedDashboard = () => {
  const role = useSelector((state) => state.auth.role);
  const isLoggingOut = useSelector((state) => state.auth.isLoggingOut);

  if (isLoggingOut) {
    return <p style={{ textAlign: 'center', marginTop: '2rem' }}>Logging out...</p>;
  }

  if (role === 'coach') {
    return <CoachDashboard />;
  } else if (role === 'athlete') {
    return <AthleteDashboard />;
  } else {
    return <p>Unauthorized or unknown role</p>;
  }
};

export default RoleBasedDashboard;